import { Component, computed, signal } from '@angular/core';
import { SplitAreaComponent, SplitComponent } from 'angular-split';

import { ICONS } from '@gfe/core/services/icons/icons.service';
import {
  CardConfig,
  CardsListComponent,
  CardsListComponentConfig
} from '@gfe/shared/components/cards-list/cards-list.component';
import { FormComponent } from '@gfe/shared/components/form/form.component';
import {
  SearchConfig,
  ToolboxComponent,
  ToolboxSection
} from '@gfe/shared/components/toolbox/toolbox.component';

@Component({
  selector: 'app-solver-cfg',
  imports: [
    ToolboxComponent,
    CardsListComponent,
    FormComponent,
    SplitComponent,
    SplitAreaComponent
  ],
  templateUrl: './solver-cfg.component.html',
  styles: ``
})
export class SolverCfgComponent {
  selectedCardId = signal<string | undefined>(undefined);

  // TODO: fetch configs from service

  featureListConfig = signal<CardsListComponentConfig>({
    noDataMessage: 'Aucune configuration disponible',
    onClick: (card: CardConfig) => this.selectCard(card),
    cards: [
      {
        id: 'objective',
        title: 'Objectif',
        description: "Configurer l'objectif du solveur",
        iconClass: ICONS.crosshair,
        isPinned: true,
        hasAccent: false,
        labels: {} as Record<string, string>
      },
      {
        id: 'temperatures',
        title: 'Températures',
        description: 'Configurer les contraintes de respect des temperatures',
        iconClass: ICONS.thermometer,
        isPinned: true,
        labels: {} as Record<string, string>
      },
      {
        id: 'capacity',
        title: 'Capacités',
        description: 'Configurer les contraintes de capacité',
        iconClass: ICONS.shippingContainer,
        isPinned: true,
        labels: {} as Record<string, string>
      },
      {
        id: 'tw',
        title: 'Fenêtres de temps',
        description: 'Configurer les contraintes de fenêtres de temps',
        iconClass: ICONS.hourglass,
        isPinned: true,
        labels: {} as Record<string, string>
      },
      {
        id: 'work-regulation',
        title: 'Réglementation du travail',
        description: 'Configurer la reglementation du travail',
        iconClass: ICONS.gavel,
        isPinned: false,
        labels: {} as Record<string, string>
      },
      {
        id: 'expertise',
        title: 'Expertises',
        description: "Configurer les contraintes d'expertises",
        iconClass: ICONS.book,
        isPinned: false,
        labels: {} as Record<string, string>
      },
      {
        id: 'location-capacity',
        title: 'Quais',
        description: 'Configurer la disponibilité des quais de chargement',
        iconClass: ICONS.factory,
        isPinned: false,
        labels: {} as Record<string, string>
      },
      {
        id: 'synchronization',
        title: 'Synchronisation',
        description: 'Configurer les contraintes de synchronisation',
        iconClass: ICONS.arrowsClockwise,
        isPinned: false,
        labels: {} as Record<string, string>
      }
    ]
  });

  toolboxSections = computed<ToolboxSection[]>(() => {
    return [
      // Actions always available
      {
        id: 'default actions',
        items: [
          {
            id: 'edit',
            icon: ICONS.pencil,
            tooltip: 'Éditer',
            callback: () => {}
          }
        ]
      }
    ];
  });

  searchCfg: SearchConfig = {
    active: true,
    type: 'simple',
    shortcut: true
  };

  selectCard(card: CardConfig): void {
    this.featureListConfig().cards.forEach((c) => {
      c.hasAccent = c.id == card.id;
    });
    this.selectedCardId.set(card.id);
  }
}
